import { useIntl } from "react-intl";

type Format = "short" | "full";

export function useIntlFormattedMonthDay(format: Format = "full") {
  const intl = useIntl();

  return (day: number) => {
    if (day >= 0) {
      return intl.formatMessage(
        {
          defaultMessage:
            "{day, selectordinal, =0 {#} one {#st} two {#nd} few {#rd} other {#th} }",
          description: "Ordinal number",
        },
        {
          day,
        }
      );
    } else if (day === -1) {
      if (format === "short") {
        return intl.formatMessage({
          defaultMessage: "Last",
          description: "useIntlFormattedMonthDay last day of month short",
        });
      } else {
        return intl.formatMessage({
          defaultMessage: "Last day of month",
          description: "useIntlFormattedMonthDay last day of month",
        });
      }
    } else if (day === -2) {
      if (format === "short") {
        return intl.formatMessage({
          defaultMessage: "2nd last",
          description:
            "useIntlFormattedMonthDay second to last day of month short",
        });
      } else {
        return intl.formatMessage({
          defaultMessage: "Penultimate day of month",
          description:
            "useIntlFormattedMonthDay second to last day of the month",
        });
      }
    }
    return "";
  };
}
